import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useToggle } from 'react-use';

import { __t } from '@mssgme/shared';
import { LandingsPropTypes } from '@mssgme/ui';
import { useCRMData, useModalThemes } from '../../../hooks';
import { ThemedButton, ThemedModal } from '../../../UI';

const propTypes = {
    order: LandingsPropTypes.order.isRequired,
    onPay: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export function OtherPayment({ order, disabled, onPay }) {
    const { payments } = useCRMData();
    const { contentStyle } = useModalThemes();
    const [isModal, toggleModal] = useToggle();

    const handleOrder = useCallback(() => onPay('other'), [onPay]);
    const handleModal = useCallback(() => {
        if (payments.other.instructions) {
            toggleModal(true);
        } else {
            handleOrder();
        }
    }, [payments.other.instructions, toggleModal]);

    return (
        <div>
            <ThemedButton fullWidth theme={contentStyle} disabled={disabled} onClick={handleModal}>
                {__t('make_order')}
            </ThemedButton>

            {isModal && (
                <ThemedModal noop compact overlay padding title={__t('payments_instructions')} onClose={toggleModal}>
                    {(handleClose) => (
                        <div>
                            <div style={{ whiteSpace: 'pre-wrap' }}>{payments.other.instructions}</div>

                            <ThemedButton fullWidth theme={contentStyle} disabled={disabled} onClick={handleClose}>
                                {__t('make_order')}
                            </ThemedButton>
                        </div>
                    )}
                </ThemedModal>
            )}
        </div>
    );
}

OtherPayment.propTypes = propTypes;
